$('#search-regional').typeahead({
        hint: true,
        highlight: true,
        minLength: 2,
        autoselect: false,
        classNames: {
            wrapper: 'twitter-typeahead-regional',
        },
    },
    {
        displayKey: 'token',
        name: 'states',
        source: function (query, syncResults, asyncResults) {
            var results = [];
            $.get({url: "/firmy/ajax_regional/", dataType: "json", data: {maxRows: 12, name_startsWith: $("#search-regional").val(),url_kategorie: $("#url_kategorie").val()}}, function (json) {
                //console.log("ajax success");
                for (i in json.results) {
                    results.push(json.results[i]);
                    //console.log(json.results[i]);
                }
                console.log(results);
                asyncResults(results);
            });
        },
        templates: {
            //empty: ['Žádný výsledek'].join('\n'),
            suggestion: function (e) {
                return '<div>' + e.label + '</div>';
            }
        },
        limit: 10
    }

)

$('#search-regional').bind('typeahead:select', function (ev, suggestion) {
    console.log('paramname='+suggestion.paramname);
    $('#paramname').val(suggestion.paramname);
    console.log('paramvalue='+suggestion.paramvalue);
    $('#paramvalue').val(suggestion.paramvalue);
    if (suggestion.url!='') {
        console.log(suggestion.url);
        location.href = suggestion.url;
    }else{
        console.log('chybí url, nebudu odesilat form, musi byt nejdrive zvolena kategorie');
        $("#search-firm").focus();

    }
});

$('#search-regional').bind('typeahead:asyncrequest', function (ev, suggestion) {
    console.log('spinner show');
    $('#search-regional').css('background-image', 'url("/images/ajax-loader.gif")');
    $('#search-regional').css('background-repeat', 'no-repeat');
    $('#search-regional').css('background-position', '95% center');

});
$('#search-regional').bind('typeahead:asyncreceive', function (ev, suggestion) {
    console.log('spinner hide');
    $('#search-regional').css('background-image', '');
});

// $("#search-both").on("click", function () {
//
//     $("#search-firm").focus();
// });

// $(".tt-hint").addClass("form-control");

